import React from 'react';
import { Container } from './styledComponent/index';

const Card = ({ children, padding, margin, bc, width }) => {
	return (
		<Container style={{backgroundColor:"white",maxHeight:"87vh",overflowY:"scroll",minHeight:"80vh"}} padding={padding} margin={margin} bc={bc} width={width}>
			{children}
		</Container>
	);
};

export default Card;
